/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import VueAxios from 'vue-axios';
import VueCookie from 'vue-cookie';
import VueMomentJS from 'vue-momentjs';
import JWTDecode from 'jwt-decode';
import { JSEncrypt } from 'jsencrypt';
import Spinner from '@/components/Spinner';
import Configuration from '@/js/Configuration';
import Constant from '@/js/Constant';
import AesWrapper from '@/js/AesWrapper';
import APIFunction from '@/js/APIFunction';
import Util from '@/js/Util';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueCookie);
Vue.use(VueMomentJS, moment);

Vue.component(Spinner.name, Spinner);
Vue.use(Constant);
Vue.use(AesWrapper);
Vue.use(APIFunction);
Vue.use(Util);

const jsEncrypt = new JSEncrypt();
jsEncrypt.setPublicKey(`${Configuration.value('RSA_PUB_KEY')}`);
Vue.prototype.$jsEncrypt = jsEncrypt;

Vue.prototype.$jwtDecode = JWTDecode;

axios.interceptors.request.use(async (config) => {
  if (!config.url.includes('/login') && !config.url.includes('/token') && !Vue.prototype.$isAccessTokenValid()) {
    if (!await Vue.prototype.$refreshToken()) {
      alert('로그인이 만료 되었습니다.\n다시 로그인 해주세요.');
      router.push({ name: 'Login' }).catch(() => { });
      return Promise.reject(new Error('Token expired'));
    }

    config.headers.Authorization = `Bearer ${Vue.cookie.get('accessToken')}`;
  }

  return config;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js